import {
  useEffect,
  useState,
  useMemo,
  ComponentProps,
} from 'react';
import { universalReferenceActions } from '../../../universal-reference/store/universalReferenceStore';
import { SelectInput } from '../forms';

/** Элемент справочника universal-reference (готового интерфейса в api нет).
 *  id — число: refId валидируется как Yup.number().min(1), см. universal-reference/validation.js */
interface RefItem {
  id: number,
  name?: string,
}

type RefSelectorProps = Omit<ComponentProps<typeof SelectInput>, 'value' | 'defaultValue'> & {
  /** Показать только элементы с этими id. */
  filterKey?: Array<number>,
  /** Исключить элементы с этими id. */
  excludeKey?: Array<number>,
};

const RefSelector = (props: RefSelectorProps) => {
  const {
    dataTitle = 'name',
    dataValue = 'id',
    filterKey,
    excludeKey,
    ...rest
  } = props;

  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState<RefItem[]>([]);

  // Мемоизированная фильтрация
  const filteredValues = useMemo(() => {
    let res = values;
    if (filterKey) {
      res = res.filter(v => filterKey.find(k => v.id === k));
    }
    if (excludeKey) {
      res = res.filter(v => !excludeKey.find(k => v.id === k));
    }
    return res;
  }, [values, filterKey, excludeKey]);

  // Загрузка при монтировании: экшен стора сам кэширует на сессию (load-once),
  // повторные mount'ы получают данные из кэша без сетевого запроса
  useEffect(() => {
    let isSubscribed = true;
    setLoading(true);

    universalReferenceActions.getRefs()
      .then((refs) => {
        if (isSubscribed) setValues(refs);
      })
      .finally(() => {
        if (isSubscribed) setLoading(false);
      });

    return () => { isSubscribed = false; };
  }, []);

  return (
    <SelectInput
      { ...rest }
      data={ filteredValues }
      dataTitle={ dataTitle }
      dataValue={ dataValue }
      loading={ loading }
      sort
    />
  );
};

export default RefSelector;
